import LeadSearchBar from 'layout/ApplicationLayout/components/LeadSearchBar/LeadSearchBar';

export default LeadSearchBar;
